<template>
  <div class="qw-error-page">
    <!-- 卡片复用全局 page-container 玻璃拟态视觉（顶部渐变条/圆角/背景模糊） -->
    <div class="page-container qw-error-page__card">
      <div class="qw-error-page__code">404</div>
      <div class="qw-error-page__text">页面不存在或已被移除</div>
      <el-button type="primary" size="small" @click="$router.replace('/userList')">返回首页</el-button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Error404'
}
</script>

<style lang="scss" scoped>
// 页面背景沿用全局 html/body 渐变光斑（business-page-theme.scss），此处不再覆盖
.qw-error-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    box-sizing: border-box;
}

// 全局 .page-container 面向列表页做了全宽强制（width 100% !important），
// 错误页覆盖为居中小卡形态；玻璃卡视觉本身（渐变条/圆角/模糊/阴影）全部沿用全局
.qw-error-page__card.page-container {
    width: 460px !important;
    max-width: calc(100vw - 32px) !important;
    margin: 0 auto !important;
    padding: 64px 48px 56px !important;
    text-align: center;
}

.qw-error-page__code {
    font-size: 72px;
    font-weight: 800;
    color: #1d4ed8;
    line-height: 1.2;
    letter-spacing: 0.02em;
}

.qw-error-page__text {
    margin: 8px 0 24px;
    color: var(--qw-text-tertiary);
    font-size: 14px;
}
</style>
